/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Menu_Secret_PromptInputs */

const en_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer Secret`)
};

const ar_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رمز المطوّر السري`)
};

const bn_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেভেলপার সিক্রেট`)
};

const de_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwicklergeheimnis`)
};

const es_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secreto del desarrollador`)
};

const fr_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secret du développeur`)
};

const pt_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segredo do desenvolvedor`)
};

const zh_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发者秘密`)
};

const tr_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliştirici Sırrı`)
};

const ru_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Секрет разработчика`)
};

const pl_dev_menu_secret_prompt = /** @type {(inputs: Dev_Menu_Secret_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekret programisty`)
};

/**
* | output |
* | --- |
* | "Developer Secret" |
*
* @param {Dev_Menu_Secret_PromptInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_menu_secret_prompt = /** @type {((inputs?: Dev_Menu_Secret_PromptInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Menu_Secret_PromptInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_menu_secret_prompt(inputs)
	if (locale === "bn") return bn_dev_menu_secret_prompt(inputs)
	if (locale === "de") return de_dev_menu_secret_prompt(inputs)
	if (locale === "es") return es_dev_menu_secret_prompt(inputs)
	if (locale === "fr") return fr_dev_menu_secret_prompt(inputs)
	if (locale === "pt") return pt_dev_menu_secret_prompt(inputs)
	if (locale === "zh") return zh_dev_menu_secret_prompt(inputs)
	if (locale === "tr") return tr_dev_menu_secret_prompt(inputs)
	if (locale === "ru") return ru_dev_menu_secret_prompt(inputs)
	if (locale === "pl") return pl_dev_menu_secret_prompt(inputs)
	return en_dev_menu_secret_prompt(inputs)
});